import { Dark } from 'quasar'

import { localStorageService } from 'src/services/app/storage.service'
import { STORAGE_KEYS } from 'src/services/consts/api.const'
import { DEFAULT_THEME, THEME } from 'src/services/consts/app.const'

export const themeService = {
  getCachedTheme,
  applyTheme,
}

/**
 * Reads the last-applied theme from localStorage, falling back to the app default.
 * Used before account data is available (boot file on startup, accountStore's initial
 * computed fallback).
 */
function getCachedTheme() {
  const cached = localStorageService.get(STORAGE_KEYS.THEME_PREFERENCE)
  return cached === THEME.DARK ? THEME.DARK : DEFAULT_THEME
}

/**
 * Applies a theme to the document: toggles `body--dark`, syncs Quasar's reactive Dark
 * state, and persists the choice to localStorage.
 */
function applyTheme(theme) {
  const isDark = theme === THEME.DARK
  if (document?.body) {
    document.body.classList.toggle('body--dark', isDark)
  }
  Dark.set(isDark)
  localStorageService.set(STORAGE_KEYS.THEME_PREFERENCE, theme)
}
